<template>
  <article class="prod-box">
    <SingleProductImage v-if="product.media === Media.IMAGE" :product="product"/>
    <SingleProductVideo v-else :product="product"/>
  </article>
</template>

<script setup lang="ts">
import {Media, Product} from "../../utils/types.ts";
import SingleProductImage from "./SingleProductImage.vue";
import SingleProductVideo from "./SingleProductVideo.vue";

interface Props {
  product: Product;
}

defineProps<Props>()
</script>
